import { Link } from "react-router-dom";
import { useFavorites } from "@/hooks/useFavorites";
import { getAllFilms } from "@/lib/films";

export default function FavoritesStrip() {
  const { favorites } = useFavorites();
  const allFilms = getAllFilms();
  const favoriteFilms = allFilms.filter((film) => favorites.includes(film.id));

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
              <i className="ri-bookmark-line text-sm" />
              我的收藏
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">收藏的作品</h2>
            <p className="mt-2 text-sm text-foreground-600">收藏记录保存在你的浏览器本地，无需登录即可随时取用。</p>
          </div>
        </div>

        {favoriteFilms.length === 0 ? (
          <div className="mt-8 flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-4 py-12 text-center">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-foreground-400">
              <i className="ri-star-line text-2xl" />
            </span>
            <p className="mt-4 text-sm text-foreground-600">还没有收藏任何作品，点击影片卡片右上角的星标即可收藏。</p>
            <Link
              to="/category/all"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-compass-3-line text-base" />
              去发现影视
            </Link>
          </div>
        ) : (
          <div className="mt-8 flex gap-4 overflow-x-auto pb-2">
            {favoriteFilms.map((film) => (
              <Link
                key={film.id}
                to={`/detail/${film.id}`}
                className="group flex w-40 shrink-0 flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 sm:w-48"
              >
                <div className="aspect-[2/3] w-full overflow-hidden bg-background-200">
                  <img src={film.poster} alt={`${film.title}海报`} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="p-3">
                  <h3 className="font-heading text-sm font-semibold text-foreground-950 line-clamp-1">{film.title}</h3>
                  <p className="mt-1 text-xs text-foreground-500">{film.year} · {film.genres[0]}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}